const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

class HeroSlider {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-hero-slide]')];
    this.dots = [...root.querySelectorAll('[data-hero-dot]')];
    this.hero = root.closest('.hero');
    if (this.slides.length < 2) return;

    this.index = 0;
    this.intervalMs = 3000;
    this.hydrated = new Set();

    this.preloadNext();

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(Number(dot.dataset.index));
        this.restart();
      });
    });

    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => this.restart());

    this.restart();
  }

  // Slide images beyond the first ship with data-src/data-srcset instead of
  // real attributes so the browser doesn't fetch all of them on page load
  // (they're stacked at inset:0, so native loading="lazy" can't defer them).
  // Hydrate one slide ahead of time instead, so it's ready before it's shown.
  hydrateSlide(index) {
    const slide = this.slides[index];
    if (!slide || this.hydrated.has(index)) return;
    this.hydrated.add(index);
    slide.querySelectorAll('source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      delete source.dataset.srcset;
    });
    slide.querySelectorAll('img[data-src]').forEach((img) => {
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
      }
      img.src = img.dataset.src;
      delete img.dataset.src;
    });
  }

  preloadNext() {
    const nextIndex = (this.index + 1) % this.slides.length;
    const schedule = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 200));
    schedule(() => this.hydrateSlide(nextIndex));
  }

  start() {
    if (prefersReducedMotion) return;
    this.stop();
    this.timer = window.setInterval(() => this.next(), this.intervalMs);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }

  restart() {
    this.start();
  }

  next() {
    this.goTo((this.index + 1) % this.slides.length);
  }

  goTo(index) {
    if (index === this.index) return;
    this.hydrateSlide(index);
    this.slides[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.classList.remove('is-active');
    this.index = index;
    // Hero text is hidden on the first slide (it has its own banner artwork).
    this.hero?.classList.toggle('hero--first-slide', index === 0);
    this.slides[this.index]?.classList.add('is-active');
    this.dots[this.index]?.classList.add('is-active');
    this.preloadNext();
  }
}

document.querySelectorAll('[data-hero-slider]').forEach((root) => new HeroSlider(root));
